import styled from 'styled-components';

export const NavBarContainer = styled.div`
  display: block;
  padding: 0 50px;
  border-bottom: solid 1px lightgray;
`;

export const NavBarLogo = styled.div`
  display: inline-block;
  height: 100%;
  width: 120px;
  text-align: center;
  vertical-align: middle;
  padding: 0 25px;
  & img {
    width: 100%;
  }
  &:hover {
    cursor: pointer;
  }
`;

export const NavBarItem = styled.div`
  display: inline-block;
  height: 100%;
  width: 120px;
  text-align: center;
  padding: 30px;
  font-weight: bold;
  font-size: 18px;
  &:hover {
    background-color: lightgray;
    cursor: pointer;
  }
`;
